import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import BoxSystem from "@mui/material/Box";
const Box = forwardRef(function Box2(props, ref) {
  const { sx, eventId, ...other } = props;
  return /* @__PURE__ */ jsx(
    BoxSystem,
    {
      ...other,
      ref,
      sx,
      "data-eventid": eventId
    }
  );
});
export {
  Box
};
//# sourceMappingURL=box.component.js.map
